
import { Component, Vue, Watch } from "vue-property-decorator";
import NotificationsManager from "@/components/NotificationsManager.vue";
import {
    readCurrentAccount,
    readCurrentSponsor,
    readIsLoggedIn,
} from "@/store/main/getters";
import { dispatchCheckLoggedIn, dispatchGetCurrentSponsor } from "@/store/main/actions";
import OverlayLoadingIndicator from "./components/OverlayLoadingIndicator.vue";

@Component({
    components: {
        NotificationsManager,
        OverlayLoadingIndicator,
    },
})
export default class App extends Vue {
    get loggedIn() {
        return readIsLoggedIn(this.$store);
    }

    get currentSponsor() {
        return readCurrentSponsor(this.$store);
    }

    get currentAccount() {
        return readCurrentAccount(this.$store);
    }

    public async created() {
        await dispatchCheckLoggedIn(this.$store);
    }

    @Watch("currentAccount", { immediate: true })
    public async onCurrentAccountChange(newVal, oldVal) {
        if (newVal) {
            console.log(newVal);
            if (this.currentAccount?.sponsored == true) {
                if (!this.currentSponsor) {
                    await dispatchGetCurrentSponsor(this.$store);
                }
                if (this.currentSponsor) {
                    this.$vuetify.theme.themes.light.primary = this.currentSponsor.color_primary;
                    this.$vuetify.theme.themes.light.secondary = this.currentSponsor.color_secondary;
                    this.$vuetify.theme.themes.light.accent = this.currentSponsor.color_accent;
                    this.$vuetify.theme.themes.light.background = this.currentSponsor.color_background;
                }
            }
        }
    }
}
